import React from 'react';
import { RouterProvider, createBrowserRouter, redirect } from 'react-router-dom';

import { config } from '_config';

import App from 'components/App';
import AccountSettingsPage from 'components/composed/pages/AccountSettingsPage';
import BookkeepingConfigurePage from 'components/composed/pages/BookkeepingConfigurePage';
import BookkeepingOverviewPage from 'components/composed/pages/BookkeepingOverviewPage';
import BookkeepingTransactionsPage from 'components/composed/pages/BookkeepingTransactionsPage';
import ErrorBoundaryPage from 'components/composed/pages/ErrorBoundaryPage';
import ForgotPasswordPage from 'components/composed/pages/ForgotPasswordPage';
import LoginPage from 'components/composed/pages/LoginPage';
import LogoutPage from 'components/composed/pages/LogoutPage';
import OAuthCallbackPage from 'components/composed/pages/OAuthCallbackPage';
import OverviewPage from 'components/composed/pages/OverviewPage';
import ResetPasswordPage from 'components/composed/pages/ResetPasswordPage';
import SupportPage from 'components/composed/pages/SupportPage';
import TaxPreparationCurrentPage from 'components/composed/pages/TaxPreparationCurrentPage';
import TaxPreparationPreviousPage from 'components/composed/pages/TaxPreparationPreviousPage';
import MainLayout from 'components/layouts/MainLayout';
import PrivateLayout from 'components/layouts/PrivateLayout';
import PublicLayout from 'components/layouts/PublicLayout';
import SettingsLayout from 'components/layouts/SettingsLayout';

import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

const routes = [
  {
    path: config.publicUrl,
    element: <App />,
    errorElement: <ErrorBoundaryPage />,
    children: [
      {
        path: 'oauth/callback',
        element: <OAuthCallbackPage />,
      },
      {
        element: <PrivateRoute />,
        children: [
          {
            element: <PrivateLayout />,
            children: [
              {
                path: 'main',
                element: <MainLayout />,
                children: [
                  { path: '', loader: () => redirect('overview') },
                  { path: 'overview', element: <OverviewPage /> },
                  {
                    path: 'bookkeeping',
                    children: [
                      { path: '', loader: () => redirect('overview') },
                      { path: 'overview', element: <BookkeepingOverviewPage /> },
                      { path: 'transactions', element: <BookkeepingTransactionsPage /> },
                      { path: 'configure', element: <BookkeepingConfigurePage /> },
                    ],
                  },
                  {
                    path: 'tax-preparation',
                    children: [
                      { path: '', loader: () => redirect('current') },
                      { path: 'current', element: <TaxPreparationCurrentPage /> },
                      { path: 'previous', element: <TaxPreparationPreviousPage /> },
                    ],
                  },
                  { path: 'support', element: <SupportPage /> },
                ],
              },
              {
                path: 'settings',
                element: <SettingsLayout />,
                children: [
                  { path: '', loader: () => redirect('main') },
                  { path: 'account', element: <AccountSettingsPage /> },
                ],
              },
              {
                path: 'logout',
                element: <LogoutPage />,
              },
            ],
          },
        ],
      },
      {
        element: <PublicRoute />,
        children: [
          {
            element: <PublicLayout />,
            children: [
              { path: '', loader: () => redirect('login') },
              { path: 'login', element: <LoginPage /> },
              { path: 'forgot-password', element: <ForgotPasswordPage /> },
              { path: 'reset-password', element: <ResetPasswordPage /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', loader: () => redirect(config.publicUrl) },
];

export const router = createBrowserRouter(routes);

const Routes = () => <RouterProvider router={router} />;

export default Routes;
